var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-line-container",on:{"click":_vm.clickStepLine}},[(_vm.stepItemData.step)?_c('div',{staticClass:"step-text",style:({
      background: _vm.returnApplicationItem(_vm.stepItemData).background,
      color: _vm.returnApplicationItem(_vm.stepItemData).color,
    })},[_vm._v(" "+_vm._s(_vm.stepItemData.step)+" ")]):_vm._e(),_c('div',{staticClass:"step-title"},[_vm._v(_vm._s(_vm.stepItemData.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }